import { Box, Button } from '@mui/material';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import React from 'react';
import { hasGoogleClientId } from '../config/googleClient';

/** GIS Sign-In With Google — ID token only (openid email profile). No Drive/People scopes. */
const GOOGLE_ID_SCOPES = 'openid email profile';

const AuthenticationComponent = ({ onLogin, onError, onDevLogin }) => {
  const showGoogle = hasGoogleClientId();

  if (process.env.REACT_APP_SUITE_SSO === 'true') {
    return <Button component="a" href="/auth/start" variant="contained">Continue with Container Labs</Button>;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
      }}
    >
      {onDevLogin && (
        <Button variant="contained" color="secondary" onClick={onDevLogin}>
          Continue as Dev
        </Button>
      )}
      {showGoogle && (
        <GoogleLogin
          // Credential (ID token) flow — do not use useGoogleLogin / access_token scopes.
          scope={GOOGLE_ID_SCOPES}
          onSuccess={(credentialResponse) => {
            const decodedToken = jwtDecode(credentialResponse.credential);
            // Pass-through only: App exchanges the credential at the auth
            // server and adopts the real session token from its response.
            onLogin(decodedToken, credentialResponse.credential);
          }}
          onError={() => {
            console.error('Google login failed');
            onError(
              'Google login failed. Authorized JavaScript origins must include this UI URL in Google Cloud Console.'
            );
          }}
          useOneTap={false}
          auto_select={false}
        />
      )}
    </Box>
  );
};

export default AuthenticationComponent;
